<ng-container *ngIf="init">
  <mat-form-field appearance="outline">
    <mat-label>Bij wie</mat-label>
    <mat-select
      matInput
      [(ngModel)]="selectedOption"
      (ngModelChange)="selectedOptionChanged()"
      [compareWith]="compareOptions"
    >
      <mat-option *ngFor="let option of collectKeyFromOptions" [value]="option">
        {{ option.label }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</ng-container>
